var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowUp = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15.414,
  height: 15,
  viewBox: "0 0 15.414 15",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.293 -4.5)"
}, /*#__PURE__*/React.createElement("line", {
  className: "a",
  y1: 14,
  transform: "translate(12 5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5,12l7-7,7,7"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.4b6ea5e0.svg";
export { ForwardRef as ReactComponent };